/**
 * Aura Internet custom JavaScript
 * Close click-pinned Reformation mega menus on scroll.
 */

document.addEventListener('DOMContentLoaded', () => {
  let lastScrollY = window.scrollY;
  let closingMenu = false;

  function closePinnedMegaMenu() {
    if (closingMenu) return;

    const menuItems = document.querySelectorAll(
      'header .menu-item-has-megamenu'
    );

    menuItems.forEach((item) => {
      const panel = item.querySelector(':scope > .mega-menu-container');
      const trigger = item.querySelector(':scope > .thb-full-menu--link');

      if (!panel || !trigger) return;

      const styles = window.getComputedStyle(panel);
      const isVisible =
        styles.display !== 'none' &&
        styles.visibility !== 'hidden' &&
        parseFloat(styles.opacity || '1') > 0 &&
        panel.getBoundingClientRect().height > 0;

      if (isVisible) {
        closingMenu = true;
        trigger.click();

        window.setTimeout(() => {
          closingMenu = false;
        }, 100);
      }
    });

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }

  window.addEventListener(
    'scroll',
    () => {
      if (Math.abs(window.scrollY - lastScrollY) < 5) return;

      closePinnedMegaMenu();
      lastScrollY = window.scrollY;
    },
    { passive: true }
  );
});

/* -------------------------------------------------------
   External footer links
------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('footer a').forEach((link) => {
    try {
      const url = new URL(link.href, window.location.origin);
      const isGoogleMap =
        url.hostname === 'maps.app.goo.gl' ||
        url.hostname.includes('google.') &&
        url.pathname.includes('/maps');

      if (isGoogleMap) {
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
      }
    } catch (error) {
      // Ignore invalid or incomplete links.
    }
  });
});


/* -------------------------------------------------------
   Colour filter — allow only one selected colour
------------------------------------------------------- */

document.addEventListener(
  'change',
  (event) => {
    const selected = event.target;

    if (
      !(selected instanceof HTMLInputElement) ||
      selected.type !== 'checkbox' ||
      !selected.checked
    ) {
      return;
    }

    const filterName = selected.name.toLowerCase();

    const isColourFilter =
      filterName.includes('filter.v.option.color') ||
      filterName.includes('filter.v.option.colour') ||
      filterName.includes('.color') ||
      filterName.includes('.colour');

    if (!isColourFilter) return;

    document
      .querySelectorAll('input[type="checkbox"]')
      .forEach((input) => {
        if (
          input !== selected &&
          input.name === selected.name &&
          input.checked
        ) {
          input.checked = false;
        }
      });
  },
  true
);